import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

/** True for `/recruitment` and every URL below it (query string and fragment ignored). */
export function isRecruitmentUrl(url: string): boolean {
  const path = url.split(/[?#]/, 1)[0] ?? '';
  return path === '/recruitment' || path.startsWith('/recruitment/');
}

/**
 * Runs `reset` whenever a navigation ends outside Recruitment. Must be called in an injection context.
 *
 * The recruitment stores are provided on the `recruitment` route, but Angular keeps a route's injector alive after the
 * user navigates away (and across logout/login, which does not reload the page). Resetting on leave gives the stores
 * the lifetime the areas expect: one Recruitment visit, never another user's or tenant's lookups or permissions.
 */
export function resetOnLeavingRecruitment(reset: () => void): void {
  inject(Router)
    .events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      filter((event) => !isRecruitmentUrl(event.urlAfterRedirects)),
      takeUntilDestroyed(),
    )
    .subscribe(() => reset());
}
